export default __webpack_public_path__ + "static/media/steve.d6d0a1b7.png";